import React from 'react';

export interface MessageThreadCardProps {
  id?: string | number;
  href: string;
  unread?: boolean;
  counterpartyName?: string;
  counterpartyAvatarUrl?: string;
  label?: string;
  preview: string;
  hasMessageBody?: boolean;
}

export const MessageThreadCard = ({
  id,
  href,
  unread = false,
  counterpartyName,
  counterpartyAvatarUrl,
  label,
  preview,
  hasMessageBody = true,
}: MessageThreadCardProps): JSX.Element => (
  <a
    id={id ? `message-thread-${id}` : undefined}
    href={href}
    className='block no-underline text-inherit hover:no-underline'
  >
    <div
      className={
        'p-4 rounded-lg bg-white border-2 transition-colors cursor-pointer shadow-sm '
        + 'hover:border-sapphire hover:shadow-md focus-within:border-sapphire '
        + (unread ? 'border-sapphire-100' : 'border-neutral-200')
      }
    >
      <h4 className='mb-2 text-base'>
        {unread && (
          <span className='text-[#fe3824] mr-1' aria-label='Unread'>●</span>
        )}
        <span className='font-semibold'>{counterpartyName}</span>
        {label && <span className='text-neutral-600'> - </span>}
        <span className='text-neutral-600'>{label}</span>
      </h4>
      <div className='flex gap-3 items-start'>
        {counterpartyAvatarUrl && (
          <img
            src={counterpartyAvatarUrl}
            alt={counterpartyName ?? ''}
            className='w-10 h-10 rounded-full object-cover flex-shrink-0'
          />
        )}
        <div
          className={
            `flex-1 whitespace-pre-line pt-1 ${
              !hasMessageBody ? 'italic text-neutral-600' : ''
            }`
          }
        >
          {preview}
        </div>
      </div>
    </div>
  </a>
);
